export const createFacebookPageViewEvent = () => {
  const { fbq = undefined } = window;
  fbq?.('track', 'PageView');
};
